export default __webpack_public_path__ + "static/media/ruba.62c323dd.jpg";